module.exports = __webpack_public_path__ + "static/thrilling-tales-of-dragon-slayers-66fad5f3c9d56f762f64a772eba71767.png";